import { Link } from 'react-router-dom';
import { Container } from '@dma/ui';
import './AboutSummary.css';

export interface AboutSummaryStat {
  label: string;
  value: string;
}

export interface AboutSummaryProps {
  introduction: string;
  statistics: AboutSummaryStat[];
}

const ICONS = [
  // calendar (سال تأسیس)
  <svg key="calendar" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <rect x="3" y="5" width="18" height="16" rx="2" />
    <path d="M3 10h18M8 3v4M16 3v4" strokeLinecap="round" />
  </svg>,
  // pickaxe/mine (معدن دارای پروانه)
  <svg key="pickaxe" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M4 20 14 10" strokeLinecap="round" />
    <path d="M10 4c3 0 7 2 9 5-3 1-7 0-9-2-1-1-1-2 0-3Z" strokeLinejoin="round" />
  </svg>,
  // map-pin (محدوده اکتشافی)
  <svg key="pin" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M12 21s7-6.5 7-11.5A7 7 0 0 0 5 9.5C5 14.5 12 21 12 21Z" strokeLinejoin="round" />
    <circle cx="12" cy="9.5" r="2.3" />
  </svg>,
  // team (مهندس و متخصص)
  <svg key="team" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <circle cx="9" cy="8" r="3" />
    <path d="M3 20c0-3.3 2.7-6 6-6s6 2.7 6 6" strokeLinecap="round" />
    <circle cx="18" cy="9" r="2.3" />
    <path d="M22 20c0-2.5-1.8-4.6-4.2-5.4" strokeLinecap="round" />
  </svg>
];

/**
 * A condensed, icon-led version of the About page for the homepage —
 * `introduction` and `statistics` are passed in from the same
 * `about.content.ts` data the /about route already uses (see the home
 * loader in app/routes.tsx), so nothing here is new or invented copy.
 */
export function AboutSummary({ introduction, statistics }: AboutSummaryProps) {
  return (
    <section className="dma-about-summary" aria-labelledby="dma-about-summary-heading">
      <Container>
        <h2 id="dma-about-summary-heading">درباره داریوش معدن آذر</h2>
        <p className="dma-about-summary__intro">{introduction}</p>

        <div className="dma-about-summary__stats">
          {statistics.map((stat, index) => (
            <div className="dma-about-summary__stat" key={stat.label}>
              <span className="dma-about-summary__icon" aria-hidden="true">
                {ICONS[index % ICONS.length]}
              </span>
              <span className="dma-about-summary__value">{stat.value}</span>
              <span className="dma-about-summary__label">{stat.label}</span>
            </div>
          ))}
        </div>

        <Link to="/about" className="dma-about-summary__link">
          بیشتر بدانید ←
        </Link>
      </Container>
    </section>
  );
}
